<template>
  <div v-if="fieldItem">
    <component-image :galleryList="JSON.parse(fieldItem.optionField)" :fieldLabel="languageSelect === 0 ? fieldItem.fieldName : fieldItem.fieldNameEn" :fieldId="fieldItem.fieldId" :languageSelect="languageSelect"  @select-theme="handleImageSelect" />
  </div>
</template>

<script>
import axios from 'axios'
import ComponentImage from './ComponentImage.vue'

export default {
  name: 'StudioThemeList',
  components: {
    'component-image': ComponentImage
  },
  props: {
    shopId: {
      type: String,
      required: true
    },
    flowId: {
      type: [String, Number],
      required: true
    },
    languageSelect: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      fieldItem: null
    }
  },
  async mounted () {
    if (this.shopId === this.shopNameData.Vela) {
      if (this.flowId) {
        this.getCustomFieldImage()
      }
    }
  },
  methods: {
    handleImageSelect (params) {
      this.$emit('select-theme', {
        fieldId: params.fieldId,
        fieldLabel: params.fieldLabel,
        index: params.index
      })
    },
    async getCustomFieldImage () {
      console.log('start getCustomFieldImage')
      this.fieldItem = null
      await axios
        .get(`${this.DNS_IP}/customField/get?shopId=${this.shopId}&conditionField=flow&conditionValue=${this.flowId}`)
        .then(async response => {
          let rs = response.data.filter(r => r.fieldType === 'Image')
          console.log('rs', rs)
          if (rs.length > 0) {
            this.fieldItem = rs[0]
          }
        })
        .catch(error => {
          console.log('error function addData : ', error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Booking/ComponentImageCalendar.vue